package team.platforma.dictionary_data.database.ai_model

import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import team.platforma.dictionarydata.database.DictionaryDatabase
import team.platforma.dictionarydata.table.AiModel

class AiModelTableImpl(
    private val dictionaryDatabase: DictionaryDatabase
): AiModelTable {

    override suspend fun addAi(model: AiModel) {
        dictionaryDatabase.aiModelQueries.addAi(model.id, model.name, model.chapter,model.description, model.cover)
    }

    override suspend fun addAiList(list: List<AiModel>) {
        list.forEach {
            dictionaryDatabase.aiModelQueries.addAi(it.id, it.name, it.chapter,it.description, it.cover)
        }
    }

    override fun observeAll(): Flow<List<AiModel>> {
       return dictionaryDatabase.aiModelQueries.selectAll().asFlow().mapToList(Dispatchers.Default)
    }

    override fun observeByChapter(chapter: Long): Flow<List<AiModel>> {
        return dictionaryDatabase.aiModelQueries.selectByChapter(chapter).asFlow().mapToList(Dispatchers.Default)
    }
}